
import { createReducer, on } from '@ngrx/store';
import { UpdateEventState } from '../../models/update/update-event-state';
import * as updateActions from './update.actions';

export const updateEventKey = 'updateEvent';

export const initialState: UpdateEventState = {
    eventUpdate: {
        assistants: 0,
        currentState: 1,
        id: 0,
        idCenter: 0,
        idStaff: '',
        observation: ''
    },
    isLoaded: false,
    isLoading: false,
    isValidate: false,
    isCancel: false,
    isRemoved: false,
    isBookingMemberValidated: false
};

export const updateEventReducer = createReducer(
    initialState,
    on(updateActions.cancelSchedule, (state) => ({
        ...state,
        isLoaded: true,
        isLoading: false
    })),
    on(updateActions.cancelScheduleSuccess, (state) => ({
        ...state,
        isLoaded: true,
        isLoading: false,
        isValidate: false,
        isCancel: true
    })),
    on(updateActions.removeSchedule, (state) => ({
        ...state,
        isLoaded: false,
        isLoading: true
    })),
    on(updateActions.removeScheduleSuccess, (state) => ({
        ...state,
        isLoaded: true,
        isLoading: false,
        isRemoved: true
    })),
    on(updateActions.validateSchedule, (state) => ({
        ...state,
        isLoaded: false,
        isLoading: true
    })),
    on(updateActions.validateScheduleSuccess, (state) => ({
        ...state,
        isLoaded: true,
        isLoading: false,
        isValidate: true,
        isCancel: false
    })),
    on(updateActions.resetUpdateSchedule, (state) => ({
        ...state,
        errorMssg: '',
        isLoaded: false,
        isLoading: false,
        isValidate: false,
        isCancel: false
    })),
    on(updateActions.setNewBooking, (state) => ({
        ...state,
        isLoaded: false,
        isLoading: true
    })),
    on(updateActions.setNewBookingSuccess, (state) => ({
        ...state,
        errorMssg: '',
        isLoaded: true,
        isLoading: false,
    })),
    on(updateActions.validateBookingMemberSchedule, (state) => ({
        ...state,
        isLoaded: false,
        isLoading: true
    })),
    on(updateActions.validateBookingMemberScheduleSuccess, (state) => ({
        ...state,
        isLoaded: true,
        isLoading: false,
        isBookingMemberValidated: true
    })),
    on(updateActions.resetBookingMemberValidation, (state) => ({
        ...state,
        isBookingMemberValidated: false
    })),
    on(updateActions.cancelBookingMemberSchedule, (state) => ({
        ...state,
        isLoaded: false,
        isLoading: true
    })),
    on(updateActions.cancelBookingMemberScheduleSuccess, (state) => ({
        ...state,
        isLoaded: true,
        isLoading: false
    })),
    on(updateActions.setNewBookingFailed, (state, mssg) => ({
        ...state,
        errorMssg: mssg.message,
        isLoaded: true,
        isLoading: false,
    })),
    on(updateActions.resetNewBookingFailed, (state) => ({
        ...state,
        errorMssg: '',
        isLoaded: true,
        isLoading: false,
    }))
);
